import { createRef, forwardRef, ForwardRefRenderFunction, useImperativeHandle } from 'react';
import Cropper, { ReactCropperElement } from 'react-cropper';
import 'cropperjs/dist/cropper.css';

const ImageCropper: ForwardRefRenderFunction<{ getImage: () => string }, { image: string }> = ({ image }, ref) => {
  const cropperRef = createRef<ReactCropperElement>();

  const getImage = () => {
    return cropperRef.current?.cropper.getCroppedCanvas().toDataURL() as string;
  };

  useImperativeHandle(ref, () => {
    return {
      getImage
    };
  });

  return (
    <Cropper
      ref={cropperRef}
      style={{ height: 262, width: '100%' }}
      zoomTo={0.5}
      initialAspectRatio={2}
      preview=".img-preview"
      src={image}
      viewMode={1}
      minCropBoxHeight={10}
      minCropBoxWidth={10}
      background={false}
      responsive={true}
      autoCropArea={1}
      checkOrientation={false} // https://github.com/fengyuanchen/cropperjs/issues/671
      guides={true}
    />
  );
};

export default forwardRef(ImageCropper);
